export default {
  name: 'Donald Draper',
}
